import _ from 'underscore';

export const getLwiContexts = (serverContext: object, flowId = 'Ads-Copilot') => {
  const firstName = _.get(serverContext, ['CurrentUser', 'FirstName']) || _.get(serverContext, ['currentUser', 'FirstName']);
  const lastName = _.get(serverContext, ['CurrentUser', 'LastName']) || _.get(serverContext, ['currentUser', 'LastName']);
  const email = _.get(serverContext, ['CurrentUser', 'Email']) || _.get(serverContext, ['currentUser', 'Email']);
  const locale = ((_.get(serverContext, ['CurrentLocale']) as string) || _.get(serverContext, ['currentLocale']) || 'en-us').toLocaleLowerCase();

  const source = 'Copilot';
  const queue = 'general';
  const engagementChannel = 'Live Chat';
  const product = 'BingAds';
  const issue = 'Advertiser-Support';

  const accountName = _.get(serverContext, ['CurrentAccount', 'Name']);
  const accountId = _.get(serverContext, ['CurrentAccount', 'Id']) || _.get(serverContext, ['currentUser', 'Id']);
  const accountNumber = _.get(serverContext, ['CurrentAccount', 'AccountNumber']);
  const advertiserType = _.get(serverContext, ['CurrentUser', 'UserRole']);
  const paymentSetting = _.get(serverContext, ['CurrentAccount', 'PaymentOption']);
  const accountCreationDate = _.get(serverContext, ['CurrentAccount', 'CreatedDate']);

  return {
    FirstName: firstName,
    LastName: lastName,
    Email: email,
    Locale: locale,
    FlowID: flowId,
    Queue: queue,
    EngagementChannel: engagementChannel,
    Product: product,
    Issue: issue,
    Source: source,
    AccountName: accountName,
    AccountId: accountId,
    AccountNumber: accountNumber,
    AdvertiserType: advertiserType,
    PaymentSetting: paymentSetting,
    AccountCreationDate: accountCreationDate,
    CustomerBusinessLocation: '',
    TitleOfThePage: document.title,
    PriorPagesVisited: '',
  };
};

export const LiveAgentState = {
  AGENT_ASSIGNMENT_READY: 'agentassignmentready',
  AGENT_ACCEPTED: 'agentaccepted',
  AGENT_END_CONVERSATION: 'agentendconversation',
  AGENT_POST_CHAT_SURVEY: 'agentpostchatsurvey',
};
